import styled from "styled-components";

import ButtonComponent from "./Button";

export const PrimaryButton = styled(ButtonComponent)`
  border: none;
  color: ${({ theme }) => theme.customTheme.palette.primaryButton.textColor};
  background-color: ${({ theme }) => theme.customTheme.palette.primaryButton.bgColor};
  opacity: ${({ disabled }) => (disabled ? "0.4" : "1")};
  height: fit-content;
  padding: 14px 24px;
  border-radius: ${({ theme }) => theme.customTheme.pxToRem(28)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(20)};
  font-weight: 700;
`;

export const SecondaryButton = styled(ButtonComponent)`
  border: none;
  color: ${({ theme }) => theme.customTheme.palette.SecondaryButton.color};
  background-color: ${({ theme }) => theme.customTheme.palette.SecondaryButton.bgColor};
  opacity: ${({ disabled }) => (disabled ? "0.4" : "1")};
`;

export const OutlineButton = styled(ButtonComponent)`
  border-radius: ${({ theme }) => theme.customTheme.pxToRem(28)};
  border: 1px solid ${({ theme }) => theme.customTheme.palette.OutlineButton.border};
  font-weight: 700;
  line-height: ${({ theme }) => theme.customTheme.pxToRem(20)};
  color: ${({ theme }) => theme.customTheme.palette.OutlineButton.color};
  background: transparent;
  padding: 8px 16px;
`;

export const OutlineButtonBordered = styled(ButtonComponent)`
  border-radius: ${({ theme }) => theme.customTheme.pxToRem(28)};
  border: 1px solid ${({ theme }) => theme.customTheme.palette.OutlineButtonBordered.border};
  font-weight: 700;
  line-height: ${({ theme }) => theme.customTheme.pxToRem(20)};
  color: ${({ theme }) => theme.customTheme.palette.OutlineButtonBordered.color};
  background: transparent;
  padding: 14px 24px;
  height: ${({ theme }) => theme.customTheme.pxToRem(48)};
`;

export const LinkButton = styled(ButtonComponent)`
  color: ${({ theme }) => theme.customTheme.palette.LinkButton.color};
  text-decoration: underline;
  border: none;
  padding: 0;
  font-weight: bold;
  font-size: 14px;
  display: inline-flex;

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    font-size: ${({ theme }) => theme.customTheme.pxToRem(16)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(20)};
  }
`;

export const SignInGoogleButton = styled(ButtonComponent)`
  font-family: Roboto;
  width: 100%;
  padding: 16px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.219px;
  max-height: 48px;
  background: ${({ theme }) => theme.customTheme.palette.SignInGoogleButton.bgColor};
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
  border: none;
  border-radius: 3px;
  color: rgba(0, 0, 0, 0.54);

  &:active {
    background: ${({ theme }) => theme.customTheme.palette.grey.greyEEE};
    filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.24)) drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.12));
    width: 100%;
  }

  &:focus {
    fill: ${({ theme }) => theme.customTheme.palette.white.standard};
    filter: drop-shadow(0px 2px 2px rgba(66, 133, 244, 0.3)) drop-shadow(0px 0px 2px rgba(66, 133, 244, 0.3));
    border: 2px solid rgba(66, 133, 244, 0.3);
  }

  &:hover {
    filter: brightness(100%);
  }

  & svg {
    margin-right: 20px;
  }
`;
